"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehousePublicClient = void 0;
const commons_logs_1 = require("@deliverr/commons-logs");
const WarehouseApiClient_1 = require("./WarehouseApiClient");
const commons_utils_1 = require("@deliverr/commons-utils");
const capMapToObj_1 = require("./capMapToObj");
const MILLISECONDS_PER_MINUTE = 60000;
class WarehousePublicClient extends WarehouseApiClient_1.WarehouseApiClient {
    constructor(config = {}) {
        const WAREHOUSE_SERVICE_URL = (0, commons_utils_1.getEnvString)("WAREHOUSE_SERVICE_URL", "");
        super({
            ...config,
            baseURL: `${config.baseURL || WAREHOUSE_SERVICE_URL}`,
        });
        if (!WAREHOUSE_SERVICE_URL) {
            commons_logs_1.log.warn("WAREHOUSE_SERVICE_URL environment variable is not set for WarehousePublicClient");
        }
    }
    /**
     * Returns warehouse along with all the meta-data we have.
     * @param id - string ID of the warehouse like "DM_CA_FAT1"
     * @throws NO_WAREHOUSE_FOUND -  when the warehouse ID is not found.
     */
    async getWarehouse(id, verbose = false) {
        if (verbose) {
            commons_logs_1.log.info(`getWarehouseData for warehouse ${id}`);
        }
        try {
            return await this.getCached(`/PUBLIC_DATA/v1/warehouses/${id}`, undefined, 10 * MILLISECONDS_PER_MINUTE);
        }
        catch (ex) {
            return this.handleError("getWarehouse", ex, id);
        }
    }
    /**
     * Returns a batch of warehouse information,
     * @param [ids] - A list of string IDs of the warehouses like ["PBD_ALP", "OWD_MIR"]
     * @throws NO_WAREHOUSE_FOUND -  when the warehouse ID is not found.
     */
    async getWarehouses(ids, verbose = false) {
        if (verbose) {
            commons_logs_1.log.info({ ids }, "getWarehousesByIds for warehouse ids");
        }
        try {
            return await Promise.all(ids.map(async (id) => (await this.getCached(`/PUBLIC_DATA/v1/warehouses/${id}`, undefined, 10 * MILLISECONDS_PER_MINUTE)).warehouse));
        }
        catch (ex) {
            return this.handleError("getWarehousesByIds", ex, ids.toString());
        }
    }
    /**
     * Returns warehouse ids with specific capabilities enabled
     */
    async getWarehousesByCapabilities(capabilities, verbose = false) {
        if (verbose) {
            commons_logs_1.log.info({ fn: `getWarehousesByCapabilities`, capabilities });
        }
        try {
            return await this.getCached(`/PUBLIC_DATA/v1/warehouses/ids`, capabilities.reduce((mapped, capability) => ({
                ...mapped,
                [capability]: true,
            }), {}));
        }
        catch (ex) {
            return this.handleError("getWarehousesByCapabilities", ex);
        }
    }
    /**
     * Returns warehouse ids with specific capabilities enabled or disabled
     */
    async getWarehousesByCapabilitiesMap(capabilityMap, verbose = false) {
        if (verbose) {
            commons_logs_1.log.info({ fn: `getWarehousesByCapabilitiesMap`, capabilityMap });
        }
        try {
            return await this.getCached(`/PUBLIC_DATA/v1/warehouses/ids`, (0, capMapToObj_1.capMapToObj)(capabilityMap));
        }
        catch (ex) {
            return this.handleError("getWarehousesByCapabilitiesMap", ex);
        }
    }
    /**
     * Returns warehouse links. This method requires authentication (at this time it is behind Auth0 legacy auth)
     * as it has been added for Warehouse Portal use.
     */
    async getWarehouseLinks(getWarehouseLinkRequest) {
        commons_logs_1.log.info(`getWarehouseLinks:`, getWarehouseLinkRequest);
        try {
            return await this.getCached(`/PUBLIC_DATA/v1/warehouse-links`, getWarehouseLinkRequest, 10 * MILLISECONDS_PER_MINUTE);
        }
        catch (ex) {
            return this.handleError("getWarehouseLinks", ex, getWarehouseLinkRequest.fromWarehouseId, getWarehouseLinkRequest.toWarehouseId);
        }
    }
}
exports.WarehousePublicClient = WarehousePublicClient;
//# sourceMappingURL=WarehousePublicClient.js.map